module.exports = __webpack_public_path__ + "img/emoji-full-picture-240x240.453aa330.png";